<template>
<nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
        <a class="navbar-brand" href="/">Infrastructure Costs Dashboard</a>
        <button type="button" class="navbar-toggler navbar-toggler-right" :class="{toggled: $sidebar.showSidebar}" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end">
            <ul class="nav navbar-nav mr-auto">
                <!-- <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li> -->
                <!-- <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown> -->
                <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li> -->
            </ul>
            <ul class="navbar-nav ml-auto col-md-2">
                <!-- <li class="nav-item">
            <a class="nav-link" href="#">
              Account
            </a>
          </li> -->

                <base-dropdown :title="this.authenticated ? 'Logged as '+ this.claims.name : 'User Actions'">
                    <a v-if="!this.authenticated" class="dropdown-item" href="#" @click="login()">Login</a>
                    <div v-else>
                        <a class="dropdown-item" href="/views/profile">User Profile</a>
                        <!-- @TODO check if admin -->
                        <a class="dropdown-item" href="/views/teams">Teams</a>
                        <a class="dropdown-item" href="/views/users">Users</a>
                        <a class="dropdown-item" href="alerts">Alerts</a>
                        <a class="dropdown-item" href="logs">Logs</a>
                    </div>
                </base-dropdown>
            </ul>
        </div>

    </div>
</nav>
</template>

<script>

import axios from 'axios'

export default {
    computed: {
        routeName() {
            const {
                name
            } = this.$route
            return this.capitalizeFirstLetter(name)
        }
    },
    data() {
        return {
            accessToken: '',
            claims: '',
            activeNotifications: false,
            authenticated: false
        }
    },
    async created() {
        this.isAuthenticated()
        this.setup()
        this.accessToken = await this.$auth.getAccessToken()

    },

    watch: {
        // Everytime the route changes, check for auth status
        '$route': 'isAuthenticated',
    },
    methods: {
        async setup() {
            this.claims = await this.$auth.getUser()
            if (this.$store.state.currentUser != this.claims['email'])
                this.$store.setUser(this.claims['email'])
                this.$nextTick(function () {
                    this.ensureUser(this.claims)
                })
        },
        async isAuthenticated() {
            this.authenticated = await this.$auth.isAuthenticated()
        },

        ensureUser(userData){
            var newUser = new FormData()
            newUser.append('access_token', this.accessToken)
            newUser.append('userData', JSON.stringify(userData))
             axios
                .post('/user/ensure', newUser, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
        },
        login() {
            this.$auth.loginRedirect('/')
        },
        async logout() {
            await this.$auth.logout()
            await this.isAuthenticated()
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications
        },
        closeDropDown() {
            this.activeNotifications = false
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false)
        }
    }
}
</script>

<style>

</style>
